<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Cuentas Bancarias</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Cuenta</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nueva Cuenta Bancaria</h5>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Banco</label>
            <input v-model="nuevaCuenta.Banco" type="text" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Número de Cuenta</label>
            <input v-model="nuevaCuenta.NumeroCuenta" type="text" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Nombre de la Cuenta</label>
            <input v-model="nuevaCuenta.NombreCuenta" type="text" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Tipo de Cuenta</label>
            <select v-model="nuevaCuenta.IdTipoCuenta" class="form-select">
              <option disabled value="">Seleccione un tipo</option>
              <option v-for="tipo in tiposCuenta" :key="tipo.IdTipoCuenta" :value="tipo.IdTipoCuenta">
  {{ tipo.Tipo }}
</option>

            </select>
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarCuenta">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Banco</th>
              <th>Número de Cuenta</th>
              <th>Nombre de la Cuenta</th>
              <th>Tipo de Cuenta</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="cuentas.length === 0">
              <td colspan="5">No hay cuentas bancarias registradas.</td>
            </tr>
            <tr v-for="cuenta in cuentas" :key="cuenta.IdCuentaBancaria">

              <td>{{ cuenta.Banco }}</td>
              <td>{{ cuenta.NumeroCuenta }}</td>
              <td>{{ cuenta.NombreCuenta }}</td>
               <td>{{ cuenta.tipocuenta?.Tipo || '-' }}</td> 
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(cuenta)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(cuenta)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    <!-- Modal Actualizar -->
<div v-if="mostrarModal" class="modal-backdrop">
  <div class="modal-content p-4" style="max-width: 900px; width: 100%;">
    <div class="modal-header">
      <h5 class="modal-title">Actualizar Cuenta</h5>
      <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
    </div>
    <div class="modal-body">
      <div class="row g-3">
  <div class="col-md-3">
    <label class="form-label">Banco</label>
    <input v-model="cuentaEditar.Banco" type="text" class="form-control" />
  </div>
  <div class="col-md-3">
    <label class="form-label">Número de Cuenta</label>
    <input v-model="cuentaEditar.NumeroCuenta" type="text" class="form-control" />
  </div>
  <div class="col-md-4">
    <label class="form-label">Nombre de la Cuenta</label>
    <input v-model="cuentaEditar.NombreCuenta" type="text" class="form-control" />
  </div>
  <div class="col-md-2">
    <label class="form-label">Tipo de Cuenta</label>
    <select v-model="cuentaEditar.IdTipoCuenta" class="form-select">
      <option disabled value="">Seleccione un tipo</option>
      <option v-for="tipo in tiposCuenta" :key="tipo.IdTipoCuenta" :value="tipo.IdTipoCuenta">
        {{ tipo.Tipo }}
      </option>
    </select>
  </div>
</div>
    </div>
    <div class="modal-footer mt-3">
      <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
      <button class="btn btn-primary" @click="actualizarCuenta">Actualizar</button>
    </div>
  </div>
</div>


      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar la cuenta <strong>{{ cuentaEliminar?.Banco }} - {{ cuentaEliminar?.NumeroCuenta }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "CuentaBancariaGestion",
  data() {
    return {
      cuentas: [],
      tiposCuenta: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      cuentaEditar: null,
      cuentaEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevaCuenta: {
        Banco: "",
        NumeroCuenta: "",
        NombreCuenta: "",
        IdTipoCuenta: "",
      },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerCuentas() {
      const res = await axios.get(`${API_URL}/cuentas-bancarias`);
      this.cuentas = res.data;
    },
    async obtenerTiposCuenta() {
      const res = await axios.get(`${API_URL}/tipocuenta`);
      this.tiposCuenta = res.data;
    },
    async guardarCuenta() {
      const { Banco, NumeroCuenta, NombreCuenta, IdTipoCuenta } = this.nuevaCuenta;
      if (!Banco || !NumeroCuenta || !NombreCuenta || !IdTipoCuenta) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/cuentas-bancarias`, this.nuevaCuenta);
        this.mostrarAlerta("Cuenta agregada", "success");
        this.nuevaCuenta = {
          Banco: "",
          NumeroCuenta: "",
          NombreCuenta: "",
          IdTipoCuenta: "",
        };
        this.mostrarFormulario = false;
        this.obtenerCuentas();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar", "danger");
      }
    },
    async abrirModal(cuenta) {
      // Asegura tener tipos de cuenta cargados antes de abrir el modal
      if (this.tiposCuenta.length === 0) {
        await this.obtenerTiposCuenta();
      }
      this._abrirModalInterno(cuenta);
    },
    _abrirModalInterno(cuenta) {
      this.cuentaEditar = {
        IdCuentaBancaria: cuenta.IdCuentaBancaria,
        Banco: cuenta.Banco,
        NumeroCuenta: cuenta.NumeroCuenta,
        NombreCuenta: cuenta.NombreCuenta,
        IdTipoCuenta: cuenta.IdTipoCuenta || cuenta.tipocuenta?.IdTipoCuenta || "",
      };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.cuentaEditar = null;
      this.mostrarModal = false;
    },
    async actualizarCuenta() {
      try {
        await axios.put(
          `${API_URL}/cuentas-bancarias/${this.cuentaEditar.IdCuentaBancaria}`,
          {
            Banco: this.cuentaEditar.Banco,
            NumeroCuenta: this.cuentaEditar.NumeroCuenta,
            NombreCuenta: this.cuentaEditar.NombreCuenta,
            IdTipoCuenta: this.cuentaEditar.IdTipoCuenta,
          }
        );
        this.mostrarAlerta("Cuenta actualizada", "success");
        this.cerrarModal();
        this.obtenerCuentas();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(cuenta) {
      this.cuentaEliminar = { ...cuenta };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.cuentaEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      try {
        await axios.delete(
          `${API_URL}/cuentas-bancarias/${this.cuentaEliminar.IdCuentaBancaria}`
        );
        this.mostrarAlerta("Cuenta eliminada", "success");
        this.obtenerCuentas();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevaCuenta = {
        Banco: "",
        NumeroCuenta: "",
        NombreCuenta: "",
        IdTipoCuenta: "",
      };
    },
  },
  mounted() {
    this.obtenerCuentas();
    this.obtenerTiposCuenta();
  },
};
</script>



<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
